<div
  class="app-shell"
  [ngClass]="{ 'nested-scroll': isNestedScroll }"
  *ngIf="!initialLoad"
  [ngStyle]="{ 'min-width.px': minPageWidth, 'padding-bottom.px': paddingBottom }"
>
  <app-header></app-header>
  <app-content></app-content>
  <app-footer *ngIf="showFooter"></app-footer>

  <app-floating-signup-button *ngIf="showSignUpButton"></app-floating-signup-button>

  <div
    class="bottom-right-controls"
    [ngStyle]="{ bottom: calculateControlsBottom(paddingBottom, isMobileDialogOpen) }"
    [class.has-padding-bottom]="paddingBottom > 0"
    [class.no-animation]="noAnimation"
    [class.mobile-dialog]="isMobileDialogOpen"
    [ngClass]="bottomRightControlsClass"
  >
    <div class="upper">
      <app-toast></app-toast>
    </div>
    <div class="lower">
      <merri-jump-to-top
        [scrollBy]="350"
        [class.hidden]="hideJumpTo"
      ></merri-jump-to-top>
      <app-assistant-trigger *ngIf="showAssistant"></app-assistant-trigger>
    </div>
  </div>
</div>

<app-initial-load *ngIf="initialLoad"></app-initial-load>
